<template>
  <div>
    <Breadcrumbs main="employees" title="Add new employee" />

    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header"><h5></h5></div>
            <form class="form theme-form" @submit.prevent>
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label>First name</label>
                      <b-form-input
                        type="text"
                        placeholder="Jan"
                        v-model="formData.firstName"
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label>Last name</label>
                      <b-form-input
                        type="text"
                        placeholder="Kowalski"
                        v-model="formData.lastName"
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>E-mail</label>
                      <b-form-input
                        type="email"
                        placeholder="Kowalski"
                        v-model="formData.mail"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Phone number</label>
                      <b-form-input
                        type="tel"
                        placeholder="555-666-222"
                        v-model="formData.phoneNum"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Work start</label>
                      <b-form-input
                        type="date"
                        placeholder="Kowalski"
                        v-model="formData.workStart"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Zip code</label>
                      <b-form-input
                        type="text"
                        v-model="formData.zip"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Street</label>
                      <b-form-input
                        type="text"
                        v-model="formData.street"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>City</label>
                      <b-form-input
                        type="text"
                        v-model="formData.city"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Driving number license</label>
                      <b-form-input
                        type="text"
                        v-model="formData.drivingLicense"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Identification document number</label>
                      <b-form-input
                        type="text"
                        v-model="formData.identificationNum"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label>Driving system</label>
                      <b-form-select
                        placeholder="Kowalski"
                        v-model="formData.drivingSys"
                        :options="options"
                      ></b-form-select>
                    </div>
                  </div>
                </div>
                <div class="media">
                  <label class="col-form-label m-r-10">Active</label>
                  <div class="media-body text-right">
                    <label class="switch">
                      <input type="checkbox" v-model="formData.active" /><span
                        class="switch-state"
                      ></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <b-button
                  type="submit"
                  @click="addEmployee"
                  variant="primary"
                  class="mr-1"
                  >Add</b-button
                >
                <b-button type="reset" variant="light">Cancel</b-button>
              </div>
            </form>
          </div>
          <div class="card">
            <div class="card-header"><h5>Do you know that?</h5></div>
            <div class="card-body"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selected: null,
      options: [
        { value: null, text: "Please select driving system" },
        { value: "3Z", text: "3 shifts system" },
        { value: "2Z", text: "2 shifts system" },
        { value: "SOLO", text: "Solo shift system" },
      ],
      formData: {
        firstName: null,
        lastName: null,
        mail: null,
        phoneNum: null,
        workStart: null,
        drivingSys: null,
        active: null,
        // 
        drivingLicense: null,
        street: null,
        identificationNum: null,
        city: null,
        zip: null,
      },
    };
  },
  methods: {
    async addEmployee() {
      try{
         await this.$store.dispatch("users/addEmployee", this.formData);
      } catch(error) {
        console.log(error)
        this.basic_success_alert("Something went wrong", 'There is a problem with adding new employee - please try again later')
      }

    },
    basic_success_alert: function(title, text) {
      this.$swal({
        title: title,
        text: text,
        type: "info",
      });
    },
  },
  computed: {
    getError() {
      const response = this.$store.getters["users/getError"];
      if (response.state) {
        return this.basic_success_alert(
          "We are sorry, employee not added",
          response.msg
        );
      }
    },
  },
};
</script>
